import {
  NOTIFICATION_ADD,
  NOTIFICATION_CLEAR_ALL,
  NOTIFICATION_REMOVE,
  NOTIFICATION_UPDATE
} from './notifications-constants'
import type { NotificationType } from './types'

const addNotification = ({
  name,
  body,
  severity,
  title = '',
  canDismiss = false
}: NotificationType) => ({
  type: NOTIFICATION_ADD,
  notification: { name, body, severity, title, canDismiss }
})

const updateNotification = (name: string, body: string) =>
  ({ type: NOTIFICATION_UPDATE, name, body })
const removeNotification = (name: string) => ({ type: NOTIFICATION_REMOVE, name })
const clearNotifications = () => ({ type: NOTIFICATION_CLEAR_ALL })

export {
  addNotification,
  clearNotifications,
  removeNotification,
  updateNotification
}
